// extracted by mini-css-extract-plugin
module.exports = {"textAreaContainer":"styles_textAreaContainer__3M4P7 flex flex-column items-start justify-between","textArea":"styles_textArea__2-LmF lato"};